// Blog articles data - Prehardcoded for development
import { getCloudflareUrl } from '../../ui/utils/cloudflareCDN';

export const blogArticles = [
  {
    id: 1,
    title: "Complete Guide to Real-Time Content Production",
    excerpt: "Discover proven strategies for creating high-quality video content in real-time. Learn about workflow processes, technical equipment, and editing techniques that actually work.",
    content: "Real-time content production is one of the most complex yet rewarding challenges in the video production industry. In this comprehensive guide, we'll explore the fundamental principles that separate successful producers from those who struggle to achieve results...",
    category: "Production",
    author: "Matías Piccinini",
    publishDate: "2024-01-15",
    readTime: "8 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/real-time-production.jpg"),
    featured: true,
    tags: ["production", "real-time", "editing", "workflow"]
  },
  {
    id: 2,
    title: "Why Your Content Strategy Isn't Working (And How to Fix It)",
    excerpt: "Are you creating content but not seeing results? Learn the common mistakes that prevent progress and discover the simple changes that will transform your video strategy.",
    content: "Many people work hard creating content but don't get the results they want. The problem isn't lack of effort - it's usually a lack of understanding about what really drives engagement...",
    category: "Strategy",
    author: "Matías Piccinini",
    publishDate: "2024-01-12",
    readTime: "6 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/content-strategy.jpg"),
    featured: true,
    tags: ["strategy", "content", "engagement", "marketing"]
  },
  {
    id: 3,
    title: "The Truth About Visual Direction: How to Create Coherent Visual Identity",
    excerpt: "Visual direction is one of the most debated aspects in video production. Cut through the confusion with evidence-based recommendations for optimal visual identity creation.",
    content: "Visual direction is the foundation of any successful video project, but there's a lot of confusion about how to implement it correctly. Let's look at best practices and separate fact from fiction...",
    category: "Direction",
    author: "Matías Piccinini",
    publishDate: "2024-01-10",
    readTime: "5 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/visual-direction.jpg"),
    featured: false,
    tags: ["visual direction", "identity", "aesthetics", "branding"]
  },
  {
    id: 4,
    title: "Mobile Studio Production: Professional Solutions Without Dependencies",
    excerpt: "Don't have access to a fixed studio? No problem. These mobile studio solutions will help you create professional content from any location.",
    content: "Fixed studios can be expensive and limiting. The good news is that you can achieve incredible results with mobile equipment and proper planning...",
    category: "Production",
    author: "Matías Piccinini",
    publishDate: "2024-01-08",
    readTime: "7 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/mobile-studio.jpg"),
    featured: true,
    tags: ["mobile studio", "equipment", "production", "flexibility"]
  },
  {
    id: 5,
    title: "How to Create Strategic BTS: The Ultimate Guide to Behind-the-Scenes Content",
    excerpt: "Transform your behind-the-scenes content with these proven strategies for creating compelling narratives. Learn the secrets to creating BTS that truly connects with your audience.",
    content: "Creating effective BTS isn't just about showing the process - it's about telling a story that adds value and connects emotionally with your audience. Here's how to do it right...",
    category: "BTS",
    author: "Matías Piccinini",
    publishDate: "2024-01-05",
    readTime: "6 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/strategic-bts.jpg"),
    featured: false,
    tags: ["bts", "behind the scenes", "narrative", "storytelling"]
  },
  {
    id: 6,
    title: "The Science of Editing: Techniques for Effective Post-Production",
    excerpt: "Learn the specific editing techniques and post-production strategies needed to create video content that truly impacts your audience.",
    content: "Effective editing isn't just about cutting and pasting - it's about creating rhythm, narrative, and emotion. Here's the complete guide...",
    category: "Post-Production",
    author: "Matías Piccinini",
    publishDate: "2024-01-03",
    readTime: "9 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/effective-editing.jpg"),
    featured: false,
    tags: ["editing", "post-production", "rhythm", "narrative"]
  },
  {
    id: 7,
    title: "High-Volume Production for Maximum Impact",
    excerpt: "Discover how high-volume production can help you achieve the visual impact you're looking for while maintaining professional quality.",
    content: "High-volume production isn't just for big studios. It's one of the most effective ways to achieve visual impact and professional quality...",
    category: "Production",
    author: "Matías Piccinini",
    publishDate: "2024-01-01",
    readTime: "7 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/high-volume-production.jpg"),
    featured: true,
    tags: ["high volume", "production", "quality", "efficiency"]
  },
  {
    id: 8,
    title: "Sports Coverage: Strategies for Effective Live Content",
    excerpt: "Discover how sports coverage strategies can help you create live content that keeps your audience engaged.",
    content: "Sports coverage is one of the most effective strategies for creating live content that truly connects. Here's how to implement it correctly...",
    category: "Sports",
    author: "Matías Piccinini",
    publishDate: "2023-12-28",
    readTime: "5 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/sports-coverage.jpg"),
    featured: false,
    tags: ["sports", "coverage", "live", "engagement"]
  },
  {
    id: 9,
    title: "AI in Post-Production: What You Need to Know",
    excerpt: "Can you use AI to improve your post-production? Learn how to properly implement artificial intelligence in your creative workflow.",
    content: "AI has become incredibly popular in post-production, but can it really improve your creative work? The answer might surprise you...",
    category: "Technology",
    author: "Matías Piccinini",
    publishDate: "2023-12-25",
    readTime: "8 min read",
    imageUrl: getCloudflareUrl("https://jiddufilms-bucket.s3.us-east-2.amazonaws.com/blog/ai-post-production.jpg"),
    featured: false,
    tags: ["artificial intelligence", "post-production", "technology", "innovation"]
  }
];

export const blogCategories = [
  "All Articles",
  "Production",
  "Strategy",
  "Direction",
  "BTS",
  "Post-Production",
  "Sports",
  "Technology"
];
